/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Item_Col_PurchaseInputs */

const vi_pl_item_col_purchase = /** @type {(inputs: Pl_Item_Col_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua`)
};

/**

* @param {Pl_Item_Col_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_item_col_purchase = /** @type {((inputs?: Pl_Item_Col_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Item_Col_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_item_col_purchase(inputs)
});